export const UI_COLORS = {
    primary:"#2D4F9B",
    secondary:"#75B9A0",
    tertiary:"#F2F3F8",
    borderColor:"#d4d4d8",
    darkGreen:"#166534",
    lightGreen:"#dcfce7",
    lightYellow:"#fef9c2",
    brown:"#854d0e",
    lightBlue:"#DBEAFE",
    appBgColor:"#f6f6f6",
    bodyTextColor:"#6B7280",
    titleTextColor:"#111111",
    headingTextColor:"#000000",
    subTitleTextColor:"#444",
    linkTextColor:"#007AFF",
    labelTextColor:"#555",
    erroTextColor:"#D32F2F",
    successTextColor:"#388E3C",
    buttonBg:"#101a2d",
    buttonDisable:"#7488ad",
    light_blue:"#1ea6d3",
    disabled_light_blue:"#7ed1ec",
    disabled_green:"#8cf1d7",
    gray: "#878D96",
    lightGray:"#D3D3D3",
    green:"#06D6A0",
    buttonRed:"#EF476F",
    yellow:"#F1BE46",
    lightRed:"#fbd9d3"
}


export const LightColors = {
    // Brand Colors
    primary: "#0C81D9",   // Brand Blue
    secondary: "#9DD75C", // Green for growth
    light_primary:"#E9F5FE",
    tertiary: "#F3F4F6",
    accent: "#F97316",    // Orange for CTAs / highlights
  
    // Backgrounds
    background: "#F9FAFB",  // App background
    secondaryBg: "#E5E7EB", // Cards, inputs
    overlayBackground:"rgba(255,255,255,0.8)",
    cardBackground: "#FFFFFF",

    borderColor:"#D1D5DB",
    errorText:"#DC2626",
  
    // Typography system
    headingText: "#111827",    // H1 (strong black)
    subHeadingText: "#0C81D9", // H2 (deep blue, brand tone)
    titleText: "#374151",      // H3 (slate gray)
    subTitleText: "#6B7280",   // Labels / smaller headings
    bodyText: "#4B5563",  
    bodySecondary: "#9CA3AF",  // Helper / secondary text
    successText: "#16A34A",
  };
  
  export const DarkColors = {
    // Brand Colors (slightly adjusted for dark mode vibrancy)
    primary: "#3B82F6",   // Bright Blue
    secondary: "#34D399", // Bright Green
    light_primary:"#223A5E",
    tertiary: "#1F2937",
    accent: "#FB923C",    // Bright Orange
  
    // Backgrounds
    background: "#111827",   // Dark background
    secondaryBg: "#1F2937",  // Darker surface (cards)
    overlayBackground:"rgba(0,0,0,0.5)",
    cardBackground: "#1E1E1E",

    borderColor:"#374151",
    errorText:"#F87171",
  
    // Typography system
    headingText: "#F9FAFB",   // White for headings
    subHeadingText: "#3B82F6", // Light Blue accent for sub-headings
    titleText: "#E5E7EB",      // Light gray for titles
    subTitleText: "#9CA3AF",   // Muted gray for subtitles
    bodyText: "#D1D5DB",       // Softer gray for body
    bodySecondary: "#9CA3AF",  // Helper / secondary
    successText: "#22C55E",
  };
  
  
  